import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import { useHelpPageFeedback } from '/@/hooks/help-center';
import { _ } from '/@/locale';

const HelpCenterArticleFeedback = ({ appInstanceId, slug }: { appInstanceId: number; slug: string }) => {
    const { feedbackGiven, sendFeedback, sending, loading } = useHelpPageFeedback(appInstanceId, slug);

    const disableButtons = loading || sending || feedbackGiven;
    const feedbackGivenThisSession = useRef<boolean>(false);

    if (!feedbackGivenThisSession.current && feedbackGiven) {
        return null;
    }

    return (
        <Box
            sx={{
                borderTop: '1px solid #e2e7e9',
                px: { xs: 2, sm: 3 },
                py: 3,
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                justifyContent='space-between'
                spacing={2}
            >
                <Typography variant='subtitle1' color='primary'>
                    {_('¿Te resulto util esta informacion?')}
                </Typography>
                <Stack direction='row' spacing={1} alignItems='center'>
                    {loading && <CircularProgress size={22} />}
                    <Button
                        variant='contained'
                        color='secondary'
                        disabled={disableButtons}
                        onClick={() => {
                            sendFeedback(true);
                            feedbackGivenThisSession.current = true;
                        }}
                        sx={{ minWidth: 120, fontWeight: 700 }}
                    >
                        {_('Si')}
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        disabled={disableButtons}
                        onClick={() => {
                            sendFeedback(false);
                            feedbackGivenThisSession.current = true;
                        }}
                        sx={{ minWidth: 120, fontWeight: 700 }}
                    >
                        {_('No')}
                    </Button>
                </Stack>
            </Stack>
            {feedbackGiven && (
                <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                    {_('Gracias por tu opinion.')}
                </Typography>
            )}
        </Box>
    );
};

export default HelpCenterArticleFeedback;
